export default __webpack_public_path__ + "static/media/activate-icon.82f8028c.svg";